import { render, staticRenderFns } from "./TrialIndex.vue?vue&type=template&id=b3de9dae&scoped=true&"
import script from "./TrialIndex.vue?vue&type=script&lang=js&"
export * from "./TrialIndex.vue?vue&type=script&lang=js&"
import style0 from "./TrialIndex.vue?vue&type=style&index=0&id=b3de9dae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3de9dae",
  null
  
)

export default component.exports